module.exports = __webpack_public_path__ + "img/SNS.6218bbfc.svg";